import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect, Provider, ReactReduxContext } from 'react-redux';
import { populateComposebox } from 'redux/modules/composeboxForm';
import { addOrganizationTab, setCurrentOrganization, removeOrganizationTab } from 'redux/modules/organization';
import { browserHistory } from 'react-router';
import { Brand, Dropdown, OrganizationPicker, Search, TabPanel } from 'components';
import MenuItem from 'material-ui/MenuItem';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import AvatarMenu from './AvatarMenu';
import OrgTabMenu from './OrgTabMenu';
import * as styles from './Navbar.scss';
import { getOrgOwnerUser } from 'redux/modules/billing';
import moment from 'moment';
var Navbar = (_dec = connect(function (state, ownProps) {
  return {
    user: state.auth.user,
    isLikeableUser: state.config.userType.isLikeableUser,
    isPartner: state.config && state.config.userType && state.config.userType.isPartner,
    currentOrganization: state.organization.current,
    selectedOrgTabs: state.organization.selectedOrgTabs,
    currentPath: ownProps.location,
    searchingOrgs: state.auth.searchingOrganizations,
    theme: state.theme,
    routing: state.routing,
    partnerSubtype: function () {
      try {
        return state.whiteLabel.Organization.OrganizationSubtype.subtype;
      } catch (e) {
        return null;
      }
    }()
  };
}, {
  addOrganizationTab: addOrganizationTab,
  getOrgOwnerUser: getOrgOwnerUser,
  populateComposebox: populateComposebox,
  removeOrganizationTab: removeOrganizationTab,
  setCurrentOrganization: setCurrentOrganization
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(Navbar, _Component);

  var _super = _createSuper(Navbar);

  function Navbar(props) {
    var _this;

    _classCallCheck(this, Navbar);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getOnTabClose", function () {
      return _this.props.selectedOrgTabs.length > 1 ? _this.removeOrganizationTab : null;
    });

    _defineProperty(_assertThisInitialized(_this), "handleComposeBtnClick", function () {
      _this.props.populateComposebox({}, _this.props.currentOrganization.id);

      browserHistory.push({
        pathname: "/org/".concat(_this.props.currentOrganization.id, "/compose"),
        state: {
          modal: true
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "removeOrganizationTab", function (organizationId) {
      // If the active tab is closed, we need to redirect to another org tab.
      if (_this.props.currentOrganization.id === organizationId) {
        var _this$props$selectedO, _this$props$selectedO2;

        var currentIndex = _this.props.selectedOrgTabs.findIndex(function (org) {
          return org.id === organizationId;
        });

        var newIndex = Math.max(0, currentIndex - 1);
        var newOrgId = _this.props.selectedOrgTabs[newIndex].id;
        var replacePath = (_this$props$selectedO = _this.props.selectedOrgTabs) !== null && _this$props$selectedO !== void 0 && (_this$props$selectedO2 = _this$props$selectedO[newIndex]) !== null && _this$props$selectedO2 !== void 0 && _this$props$selectedO2.savedPath ? _this.props.selectedOrgTabs[newIndex].savedPath : '/';
        browserHistory.replace(replacePath);
      }

      _this.props.removeOrganizationTab(organizationId);
    });

    _this.state = {
      showSlider: false
    };
    return _this;
  }

  _createClass(Navbar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.selectedOrgTabs.length && this.props.user) {
        this.props.addOrganizationTab(this.props.user.Organizations[0]);
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {// const currentPathParts = browserHistory.getCurrentLocation().pathname.split('/');
      // // Update the path if the selected organization is no longer correct (i.e. it was removed)
      // const doUpdatePath = currentPathParts[1] === 'org'
      //   && currentPathParts[2]
      //   && currentPathParts[2] !== nextProps.currentOrganization.id;
      //
      // if (doUpdatePath) {
      //   currentPathParts[2] = nextProps.currentOrganization.id;
      //   const link = currentPathParts.join('/');
      //   browserHistory.replace(link);
      // }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          position = _this$props.position,
          theme = _this$props.theme,
          searchingOrgs = _this$props.searchingOrgs,
          user = _this$props.user;
      var wrapStyle = {
        width: this.props.innerWidth
      };
      var isPartnerOwner = user && (user.isPartnerOwner || user.isLikeableLocal && user.likeablelocalAllowedWhitelabel);
      var isSMB = this.props.currentOrganization.organizationTypeId === 3 && !this.props.user.isPartner;
      var tabData = this.props.selectedOrgTabs.map(function (org) {
        var link = org.id === _this2.props.currentOrganization.id && !location.pathname.includes('global') ? null : org.savedPath || "/org/".concat(org.id);
        return {
          title: org.name,
          id: org.id,
          link: link,
          active: _this2.props.params.organizationId === org.id
        };
      });
      var name = this.props.user ? "".concat(this.props.user.firstName, " ").concat(this.props.user.lastName) : '';

      var orgCanceledMessage = function () {
        var org = _this2.props.currentOrganization;

        if (org.status !== 'pending_cancel' && org.status !== 'cancelled') {
          return false;
        }

        return "The subscription for ".concat(org.name, " will end on ").concat(moment(org.paidToDate).format('MM/DD/YYYY'), ".");
      }();

      var orgPastDueMessage = function () {
        var org = _this2.props.currentOrganization;

        if (!org.gracePeriodState || org.gracePeriodState === '0') {
          return false;
        }

        return "This client's account is past due and service will be terminated on ".concat(moment(org.paidToDate).add(20, 'days').format('MMMM Do YYYY'), ". Certain functionality may be disabled before then.");
      }();

      var bannerMessage = orgCanceledMessage || orgPastDueMessage;
      var inAdminScreen = this.props.routing && this.props.routing.locationBeforeTransitions && this.props.routing.locationBeforeTransitions.pathname.indexOf('/global') !== -1;
      var adminNavItems = [];

      if (!this.props.isLikeableUser) {
        adminNavItems = [{
          link: '/global/clients',
          linkText: this.props.partnerSubtype === 'multilocation' ? 'Locations' : 'Clients'
        }, {
          link: '/global/team',
          linkText: 'Team'
        }, {
          link: '/global/report-builder',
          linkText: 'Report Builder'
        }, {
          link: '/global/group-posts',
          linkText: 'Group Posts'
        }, {
          link: '/global/whitelabel',
          linkText: 'White Labeling'
        }, isPartnerOwner && {
          link: '/global/partner',
          linkText: 'Settings'
        }].filter(function (o) {
          return o;
        });
      } else if (this.props.isLikeableUser) {
        var canAccessPartners = this.props.user && this.props.user.Roles && this.props.user.Roles.length && this.props.user.Roles.some(function (role) {
          return role.id === 1;
        });
        adminNavItems = [{
          link: '/global/clients',
          linkText: this.props.partnerSubtype === 'multilocation' ? 'Locations' : 'Clients'
        }, canAccessPartners && this.props.theme.org === 0 ? {
          link: '/global/dashboard',
          linkText: 'Dashboard'
        } : null, canAccessPartners && this.props.theme.org === 0 ? {
          link: '/global/partners',
          linkText: 'Partners'
        } : null, {
          link: '/global/team',
          linkText: 'Team'
        }, {
          link: '/global/report-builder',
          linkText: 'Report Builder'
        }, {
          link: '/global/group-posts',
          linkText: 'Group Posts'
        }, canAccessPartners && this.props.theme.org === 0 && !this.props.likeablelocalAllowedWhitelabel ? {
          link: '/global/agreements',
          linkText: 'Agreements'
        } : null, {
          link: '/global/whitelabel',
          linkText: 'White Labeling'
        }, isPartnerOwner && {
          link: '/global/partner',
          linkText: 'Settings'
        }, canAccessPartners && this.props.theme.org === 0 ? {
          link: '/global/package-manager',
          linkText: 'Package Manager'
        } : null].filter(function (o) {
          return o;
        });
      }

      var activeLogo = false;

      if (this.props.isPartner && (location.pathname.includes('global') || location.pathname.includes('user/billing') || location.pathname.includes('user/commissions'))) {
        activeLogo = true;
      }

      return /*#__PURE__*/React.createElement("nav", {
        className: styles.nav
      }, /*#__PURE__*/React.createElement("div", {
        style: wrapStyle,
        className: "row between-xs ".concat(styles.wrapStyle)
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.brandWrap,
        style: activeLogo ? {
          backgroundColor: 'white',
          height: 70,
          borderBottom: "1px solid ".concat(theme.colors.gray3)
        } : {}
      }, /*#__PURE__*/React.createElement(Brand, {
        text: "LikeableLocal",
        theme: this.props.theme,
        isPartner: this.props.isPartner,
        image_url: this.props.theme.logo,
        link: this.props.isPartner ? '/global' : '/'
      }), this.props.isPartner && /*#__PURE__*/React.createElement(IconMenu, {
        anchorOrigin: {
          horizontal: 'left',
          vertical: 'bottom'
        },
        className: styles.dropDownWrap,
        style: {
          position: 'absolute'
        },
        iconButtonElement: /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement("i", {
          className: "icon ion-ios-arrow-down ".concat(styles.dropDownIcon)
        }))
      }, adminNavItems.map(function (item, index) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          key: index,
          primaryText: item.linkText,
          onClick: function onClick() {
            return browserHistory.push({
              pathname: "".concat(item.link)
            });
          }
        });
      }))), /*#__PURE__*/React.createElement("div", {
        className: styles.tabWrap
      }, /*#__PURE__*/React.createElement(TabPanel, {
        tabData: tabData,
        onTabClose: this.getOnTabClose()
      })), !isSMB ? /*#__PURE__*/React.createElement("div", {
        className: styles.organizationControls
      }, /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (ctx) {
        return /*#__PURE__*/React.createElement(IconMenu, {
          anchorOrigin: {
            horizontal: 'left',
            vertical: 'bottom'
          },
          iconButtonElement: /*#__PURE__*/React.createElement(IconButton, {
            style: {
              padding: 0,
              height: 40,
              width: 56
            }
          }, /*#__PURE__*/React.createElement("div", {
            className: styles.controlButton
          }, /*#__PURE__*/React.createElement("i", {
            className: "icon ion-android-add"
          })))
        }, /*#__PURE__*/React.createElement(Provider, {
          store: ctx.store
        }, /*#__PURE__*/React.createElement(OrganizationPicker, {
          style: {
            width: '185px'
          }
        })));
      }), /*#__PURE__*/React.createElement(OrgTabMenu, null)) : this.props.user.UserOrganizations && this.props.user.UserOrganizations.length > 1 ? /*#__PURE__*/React.createElement("div", {
        className: styles.organizationControls
      }, /*#__PURE__*/React.createElement(OrgTabMenu, {
        overrideOrgs: _toConsumableArray(this.props.user.UserOrganizations).reduce(function (acc, obj) {
          return [].concat(_toConsumableArray(acc), [obj.Organization]);
        }, [])
      })) : null, /*#__PURE__*/React.createElement("div", {
        className: styles.rightWrap
      }, !inAdminScreen && /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles.composeButton, " ").concat(styles.composeButtonLink),
        onClick: this.handleComposeBtnClick
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.composeButtonText
      }, "COMPOSE"), /*#__PURE__*/React.createElement("span", {
        className: "icon ion-ios-compose-outline ".concat(styles.composeButtonIcon)
      })), /*#__PURE__*/React.createElement(AvatarMenu, null), /*#__PURE__*/React.createElement("div", {
        className: styles.search
      }, /*#__PURE__*/React.createElement(Search, {
        className: styles.search
      })))), bannerMessage && !inAdminScreen && /*#__PURE__*/React.createElement("div", {
        className: styles.pastDueBanner
      }, bannerMessage));
    }
  }]);

  return Navbar;
}(Component), _defineProperty(_class2, "propTypes", {
  position: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  currentOrganization: PropTypes.object.isRequired,
  selectedOrgTabs: PropTypes.array,
  addOrganizationTab: PropTypes.func.isRequired,
  removeOrganizationTab: PropTypes.func.isRequired,
  innerWidth: PropTypes.string
}), _defineProperty(_class2, "contextTypes", {
  router: PropTypes.object
}), _defineProperty(_class2, "defaultProps", {
  bgColor: '#f1f1f1',
  position: 'static',
  logoAltText: 'Likeable Local',
  innerWidth: '100%'
}), _temp)) || _class);
export default Navbar;